export default defineNuxtPlugin(async () => {
  const { refresh } = useAuth();
  const refreshToken = useCookie("auth.refresh-token");
  if (refreshToken.value) {
    refresh().catch(() => {});
  }
});
